import React from 'react';
import { fetchDrivingDistanceKm } from '../utils/drivingKm';

/**
 * Honnan–hová címek alapján km számítás (place ID vagy szöveges cím).
 * @param {React.MutableRefObject<object>} formRef – mindig a legfrissebb form objektum (batch onResolved-hez).
 * @param {function} setForm – React setState a formra
 */
export function useDrivingKmForRoute(formRef, setForm) {
  const [distanceLoading, setDistanceLoading] = React.useState(false);
  const [distanceError, setDistanceError] = React.useState('');
  const distanceReqSeqRef = React.useRef(0);

  const calculateDistanceIfReady = React.useCallback(
    async (originPlaceId, destinationPlaceId, originAddress, destinationAddress) => {
      const hasPlaceIds = !!originPlaceId && !!destinationPlaceId;
      const hasAddresses =
        !!String(originAddress || '').trim() && !!String(destinationAddress || '').trim();
      if (!hasPlaceIds && !hasAddresses) {
        setDistanceError('');
        setDistanceLoading(false);
        return;
      }
      const reqSeq = Date.now() + Math.random();
      distanceReqSeqRef.current = reqSeq;
      setDistanceLoading(true);
      setDistanceError('');
      try {
        const km = await fetchDrivingDistanceKm(
          originPlaceId,
          destinationPlaceId,
          originAddress,
          destinationAddress,
        );
        if (distanceReqSeqRef.current !== reqSeq) return;
        setForm((prev) => ({ ...prev, distanceKm: String(km) }));
      } catch (error) {
        if (distanceReqSeqRef.current !== reqSeq) return;
        setDistanceError(error.message || 'A távolságot most nem tudtuk kiszámolni.');
        setForm((prev) => ({ ...prev, distanceKm: '' }));
      } finally {
        if (distanceReqSeqRef.current === reqSeq) setDistanceLoading(false);
      }
    },
    [setForm],
  );

  return { distanceLoading, distanceError, calculateDistanceIfReady };
}
